<template>
    <ideo-form-group :label="$t('[[[Treść instrukcji]]]')" :invalid-feedback="form.$errors.first('description')" :state="form.$errors.state('description')">
        <editor id="description" v-model="form.settings.description"></editor>
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import merge from 'lodash/merge';

@Options({
    name: 'module-el-events-settings'
})
export default class eventsSettings extends Vue
{
    @Prop() public modelValue!: any;

    public defaults: any = {
        description: ''
    };

    public get form(): any
    {
        return this.modelValue;
    }

    public created(): void
    {
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', { deep: true })
    public onSettingsChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        return this.form;
    }
}
</script>
